import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const PECoatedRolls = () => <ProductDetailPage {...getProductPageConfig('peCoatedRolls')} />;

export default PECoatedRolls;
